import { render, staticRenderFns } from "./BlackListEdit.vue?vue&type=template&id=733ed372&"
import script from "./BlackListEdit.vue?vue&type=script&lang=js&"
export * from "./BlackListEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports